import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("foreignObject", {
        width: "12.658",
        height: "8.967",
        x: ".606",
        y: "2.52"
      }, [
        _createElementVNode("div", {
          xmlns: "http://www.w3.org/1999/xhtml",
          style: {"backdrop-filter":"blur(.66px)","clip-path":"url(#b)","height":"100%","width":"100%"}
        })
      ]),
      _createElementVNode("path", {
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": ".75",
        d: "M2.834 9.789h-.01l.005-.014.044-.15c.103-.34.165-.545.38-1.243.357-1.166.81-2.658 1.089-3.578.102-.337.128-.402.163-.445l-.292-.235.292.235a.4.4 0 0 1 .152-.113c.051-.02.122-.027.474-.027h6.008c.164 0 .263 0 .335.006a.4.4 0 0 1 .06.01q.021.014.031.039.001.009-.004.06c-.009.072-.03.168-.064.328l-.967 4.476a6 6 0 0 1-.087.369.4.4 0 0 1-.051.125l.305.218-.305-.218a.4.4 0 0 1-.157.126.4.4 0 0 1-.132.024 6 6 0 0 1-.376.007H2.834Z",
        "data-figma-bg-blur-radius": "1.324"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M2.782 1.846a1.4 1.4 0 0 0-.238.2l-.242.227a.54.54 0 0 1-.37.146.61.61 0 0 0-.612.612v5.617c0 .534 0 .801.106 1.004a.9.9 0 0 0 .224.282c.036-.077.067-.182.11-.325l.051-.173.421-1.372c.364-1.183.819-2.67 1.13-3.69.13-.427.195-.641.323-.8.112-.14.259-.248.425-.315.189-.075.412-.075.86-.075h5.6a.9.9 0 0 0-.078-.36.75.75 0 0 0-.32-.32c-.163-.085-.376-.085-.803-.085h-2.66c-.16 0-.24 0-.317-.018a.7.7 0 0 1-.182-.073c-.067-.04-.125-.095-.24-.207l-.068-.065a1.4 1.4 0 0 0-.24-.206.7.7 0 0 0-.183-.074c-.076-.018-.156-.018-.317-.018h-1.89c-.156 0-.235 0-.31.017a.7.7 0 0 0-.18.071m7.498 8.3q-.098.003-.23.002H2.253c.15.01.336.01.577.01h7.154c.135 0 .226 0 .296-.011",
        "clip-rule": "evenodd",
        style: {"fill-opacity":".4"}
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "b" }, [
        _createElementVNode("path", { d: "M2.228 7.269h-.01l.004-.014.045-.15c.103-.34.165-.545.38-1.243.356-1.166.81-2.658 1.088-3.578.103-.337.13-.403.164-.445l-.292-.235.292.235a.4.4 0 0 1 .152-.113c.05-.02.121-.027.474-.027h6.008c.164 0 .262 0 .334.006a.4.4 0 0 1 .06.009q.022.015.032.04.001.007-.004.06c-.009.071-.03.168-.064.328l-.967 4.476a6 6 0 0 1-.087.369.4.4 0 0 1-.051.124l.305.218-.305-.218a.4.4 0 0 1-.157.127.4.4 0 0 1-.132.024 6 6 0 0 1-.376.007H2.228" })
      ]),
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z",
          style: {"fill":"#fff","fill-opacity":"1"}
        })
      ])
    ], -1)
  ])))
}
export default { render: render }